import { lazy } from 'react'

export const Period = lazy(() => import('./Period'))
